/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchEvidencesJobExportDryRunResultInput = {
  jobRunId: string;
  tenantId: string;
};

export type ExportBatchEvidencesJobDryRunResultQueryVariables = Exact<{
  input: Types.BatchEvidencesJobExportDryRunResultInput;
}>;


export type ExportBatchEvidencesJobDryRunResultQuery = { cnutExportBatchEvidencesJobDryRunResult: string };


export const ExportBatchEvidencesJobDryRunResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportBatchEvidencesJobDryRunResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchEvidencesJobExportDryRunResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutExportBatchEvidencesJobDryRunResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ExportBatchEvidencesJobDryRunResultQuery, ExportBatchEvidencesJobDryRunResultQueryVariables>;